/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getUserLabTestItems } from 'app/entities/user-lab-test-item/user-lab-test-item.reducer';
import { getEntities as getDiagLabPanels } from 'app/entities/diag-lab-panel/diag-lab-panel.reducer';
import { createEntity, getEntity, reset, updateEntity } from './user-panel-item.reducer';

export const UserPanelItemUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const userLabTestItems = useAppSelector(state => state.userLabTestItem.entities);
  const diagLabPanels = useAppSelector(state => state.diagLabPanel.entities);
  const userPanelItemEntity = useAppSelector(state => state.userPanelItem.entity);
  const loading = useAppSelector(state => state.userPanelItem.loading);
  const updating = useAppSelector(state => state.userPanelItem.updating);
  const updateSuccess = useAppSelector(state => state.userPanelItem.updateSuccess);

  const handleClose = () => {
    navigate(`/user-panel-item${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getUserLabTestItems({}));
    dispatch(getDiagLabPanels({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }

    const entity = {
      ...userPanelItemEntity,
      ...values,
      item: userLabTestItems.find(it => it.id.toString() === values.item?.toString()),
      panel: diagLabPanels.find(it => it.id.toString() === values.panel?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...userPanelItemEntity,
          item: userPanelItemEntity?.item?.id,
          panel: userPanelItemEntity?.panel?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.userPanelItem.home.createOrEditLabel" data-cy="UserPanelItemCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.userPanelItem.home.createOrEditLabel">Create or edit a UserPanelItem</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="user-panel-item-id"
                  label={translate('tinyMedicRestApp.userPanelItem.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.userPanelItem.active')}
                id="user-panel-item-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userPanelItem.lastupdated')}
                id="user-panel-item-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userPanelItem.microSec')}
                id="user-panel-item-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userPanelItem.timestampentry')}
                id="user-panel-item-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userPanelItem.cursor')}
                id="user-panel-item-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                id="user-panel-item-item"
                name="item"
                data-cy="item"
                label={translate('tinyMedicRestApp.userPanelItem.item')}
                type="select"
              >
                <option value="" key="0" />
                {userLabTestItems
                  ? userLabTestItems.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="user-panel-item-panel"
                name="panel"
                data-cy="panel"
                label={translate('tinyMedicRestApp.userPanelItem.panel')}
                type="select"
              >
                <option value="" key="0" />
                {diagLabPanels
                  ? diagLabPanels.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/user-panel-item" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default UserPanelItemUpdate;
